import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";
import type { IntegrationStatusResponse } from "../../../components/types";
import type { CRMListObjectsType } from "../../../types";

export type HubspotTogglesServiceType = {
    getHsExclusionStatus(): Promise<{ value: boolean }>;
    getCompaniesStatusHubspot(): Promise<{ value: boolean }>;
    putHsExcludeStatus(state: boolean): Promise<IntegrationStatusResponse>;
    putHsContactsFilterStatus(state: boolean): Promise<IntegrationStatusResponse>;
    putHsCompaniesFilterStatus(state: boolean): Promise<IntegrationStatusResponse>;
    setIsHsCrmLabelEnabled(state: boolean): Promise<IntegrationStatusResponse>;
    setIsHsCrmListEnabled(state: boolean): Promise<IntegrationStatusResponse>;
    setHsCrmListObjectsType(state: CRMListObjectsType): Promise<IntegrationStatusResponse>;
};

export const hubspotTogglesService = (fetchService: IFetchService): HubspotTogglesServiceType => ({
    getHsExclusionStatus: createCancelable((signal: AbortSignal): Promise<{ value: boolean }> => {
        return fetchService
            .get<{ value: boolean } | null>(`sales-api/hubspot/leads-filter-toggle`, undefined, {
                cancellation: signal,
            })
            .then((res) => ({ value: res?.value ?? false }));
    }),
    getCompaniesStatusHubspot: createCancelable((signal: AbortSignal): Promise<{ value: boolean }> => {
        return fetchService.get("sales-api/hubspot/export-toggle", undefined, {
            cancellation: signal,
        });
    }),
    putHsExcludeStatus: createCancelable((signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
        return fetchService.put(`sales-api/hubspot/leads-filter-toggle?value=${state}`, undefined, {
            cancellation: signal,
        });
    }),
    putHsContactsFilterStatus: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`sales-api/hubspot/contact-export-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    putHsCompaniesFilterStatus: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`sales-api/hubspot/export-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    setIsHsCrmLabelEnabled: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`/sales-api/hubspot/crm-labels-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    setIsHsCrmListEnabled: createCancelable(
        (signal: AbortSignal, state: boolean): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`/sales-api/hubspot/crm-list-toggle?value=${state}`, undefined, {
                cancellation: signal,
            });
        },
    ),
    setHsCrmListObjectsType: createCancelable(
        (signal: AbortSignal, value: CRMListObjectsType): Promise<IntegrationStatusResponse> => {
            return fetchService.put(`/sales-api/hubspot/crm-list/monitor-types?value=${value}`, undefined, {
                cancellation: signal,
            });
        },
    ),
});
